module.exports = __webpack_public_path__ + "media/images/vk-1ab663f79829e7330cd5b5954ddb4a82.svg";